import {observer} from 'mobx-react-lite'
import PageLayout from './PageLayout'
import appStore from '../storage/AppStore'
import {Divider} from 'primereact/divider'
import {Tag} from 'primereact/tag'
import React from 'react'
import systemStore from "../storage/SystemStore";
import {Skeleton} from "primereact/skeleton";
import clubStore from '../storage/ClubStore'
import Btn from '../ui/Btn'
import {useNavigate} from 'react-router-dom'
import ReadonlyMap from "../ui/ReadonlyMap";
import {HtmlDiv, withHttps} from "../common/utils";
import {getProduct} from '../common/config'

const product = getProduct()

const InfoRow = ({ icon, label, value }) => {
  if (!value) return null

  return (
    <div className="flex align-items-center gap-2 mb-2 text-sm">
      <i className={`pi ${icon} text-500`} />
      <span className="text-500">{label}:</span>
      <>{value}</>
    </div>
  )
}

const CompanyInfo = ({club, trainers, teams}) => {
    const navigate = useNavigate()
    if (systemStore.loading || !club) {
        return (
            <PageLayout header={<Skeleton className="mb-2" height={"2rem"}/>}>
                <Skeleton width="10rem" className="mb-2"/>
                <Skeleton width="5rem" className="mb-2"/>
                <Skeleton height="2rem" className="mb-2"/>
                <Skeleton width="10rem" height="8rem"/>
            </PageLayout>
        )
    }
    return (
        <PageLayout
            header={
                <div className="flex align-items-center justify-content-between">
                    <h3 className="m-0">{appStore.tr.club_info}</h3>
                    {clubStore.is_manager === true && (
                        <Btn icon={"pi pi-pencil"} onClick={() => {
                            navigate('/manager/company/edit')
                        }}/>
                    )}
                </div>
            }
        >
            {/* Club main card */}
            <div className="card shadow-1 mb-3 px-2 mx-2">

                <div className="flex justify-content-between align-items-start gap-3">
                    {/* Left: text */}
                    <div className="flex flex-column gap-2">
                        <div className="flex align-items-center gap-3 justify-content-between">
                          <h2 className="m-0">{club.name}</h2>


                        </div>

                        {(club.country || club.region || club.district) && (
                          <div className="text-600 text-sm flex align-items-center gap-2">
                            <i className="pi pi-flag-fill" />
                            {[club.country?.name, club.region?.name, club.district?.name]
                              .filter(Boolean)
                              .join(" · ")}
                          </div>
                        )}
                        {club.logo && (
                            <div className={"flex align-items-center justify-content-center"}>
                                <img
                                    src={club.logo}
                                    alt={club.name}
                                    style={{
                                        width: 250,
                                        objectFit: "contain",
                                        borderRadius: 8
                                    }}
                                />
                            </div>
                        )}

                        {club.about && (
                            <HtmlDiv content={club.about}/>
                        )}
                        {club.status === "pending" && (
                            <Btn
                              label={appStore.tr.this_is_my_club || 'My Club'}
                              severity="warning"
                              size="small"
                              onClick={() => {
                                  window.open('https://t.me/clubnumberone_bot', '_blank');
                              }}
                            />
                          )}
                    </div>
                </div>

                <Divider/>

                <div className="grid">
                    <div className="col-12 md:col-6">
                        <InfoRow icon="pi-users" label={product === 'club1' ? appStore.tr.sport_types : appStore.tr.course_types}
                                 value={club.sport_names?.map((sport) =>
                                     <span key={sport.id}>{sport.icon} {sport.name}&nbsp;&nbsp;</span>)}/>
                        <InfoRow icon="pi-map-marker" label={appStore.tr.address} value={<span>{club.address}</span>}/>
                        {club.phone_number && (
                            <InfoRow icon="pi-phone" label={appStore.tr.phone_number}
                                     value={<a href={`tel:${club.phone_number}`}
                                               target={"_blank"} className={"info-link"}>{club.phone_number}</a>}/>
                        )}
                        {club.telegram && (
                            <InfoRow icon="pi-telegram" label="Telegram" value={
                                <a href={`https://t.me/${club.telegram}`} target={"_blank"} className={"info-link"}>{club.telegram}</a>
                            }/>
                        )}
                        {club.whatsapp && (
                            <InfoRow icon="pi-whatsapp" label="WhatsApp" value={
                                <a href={`https://wa.me/${club.whatsapp}`} target={"_blank"} className={"info-link"}>{club.whatsapp}</a>
                            }/>
                        )}
                        {club.instagram && (
                            <InfoRow icon="pi-instagram" label="Instagram" value={
                                <a href={`https://instagram.com/${club.instagram}`}
                                   target={"_blank"} className={"info-link"}>{club.instagram}</a>
                            }/>
                        )}
                        {club.website && (
                            <InfoRow icon="pi-globe" label="Website" value={
                                <a href={withHttps(club.website)} target={"_blank"} className={"info-link"}>{club.website}</a>
                            }/>
                        )}
                    </div>
                </div>
            </div>
  
          {trainers && trainers.length > 0 && (
            <h4 className="m-0 mt-3 mb-3">
                <i className="pi pi-user text-orange-300 mr-2"/>
                {product === 'club1' ? appStore.tr.trainers : appStore.tr.teachers}
            </h4>
          )}
            <div className="trainer-row">
                {trainers?.map((trainer, index) => (
                    <div key={index} className="trainer-card">
                        <div className="trainer-image">
                            <img
                                src={trainer.avatar}
                                alt={trainer.title}
                                loading="lazy"
                            />
                        </div>

                        <div className="trainer-name">
                            {trainer.title}
                        </div>
                    </div>
                ))}
            </div>
          {teams && teams.length > 0 && (
            <h4 className="m-0 mt-3 mb-3">
                <i className="pi pi-users text-green-300 mr-2"/>
                {appStore.tr.teams}:
            </h4>
          )}
            <div className="teams-grid">
                {teams?.map((team, index) => (
                    <div key={team.id ?? index} className="team-card-h card shadow-1 p-2">
                        <div className="team-main">
                            <div className={"flex align-items-center justify-content-between"}>
                                <span className="team-name">{team.sport?.icon} {team.name}</span>
                                {team.fee > 0 && <div className="team-fee">{team.fee}{team.currency}</div>}
                            </div>

                            {team.location?.name && (
                                <span className="team-location">
            <i className="pi pi-map-marker"/>
                                    {team.location.name}, {team.location.address}
          </span>
                            )}

                            {Array.isArray(team.schedule) && team.schedule.some(s => s.is_on) && (
                                <div className="team-schedule">
                                    {team.schedule
                                        .filter(s => s.is_on)
                                        .map((s, i) => (
                                            <span key={i} className="team-slot">
                  <b className="capitalize">{appStore.tr[s.name]}</b>
                                                {s.time_from && s.time_to && <> · {s.time_from}–{s.time_to}</>}
                </span>
                                        ))}
                                </div>
                            )}
                        </div>


                    </div>
                ))}
            </div>
          
            {/* Locations */}
            {club.locations?.length > 0 &&
                <h4 className="m-0 mt-3 mb-3"><i
                    className="pi pi-map-marker text-blue-300"/> {appStore.tr.locations}:
                </h4>}
            {club.locations?.length > 0 && club.locations?.map((location, index) => (
                <div key={index} className="card shadow-1 mb-1 mx-2 p-2">

                    <div className="flex justify-content-between align-items-center mb-2">
                        <div className="font-semibold text-lg">
                            {location.name}
                        </div>

                        {location.is_main && (
                            <Tag severity="success" value={appStore.tr.main_location}/>
                        )}
                    </div>

                    {location.address && (
                        <div className="text-600 text-sm mb-2">
                            <i className="pi pi-map-marker mr-1"/>
                            {location.address}
                        </div>
                    )}

                    <div className="border-round overflow-hidden mt-2">
                      <ReadonlyMap point={location.location} tr={appStore.tr} />
                    </div>
                </div>
            ))}
        </PageLayout>
    )
}

export default observer(CompanyInfo)
